import React from "react"
import Figures from "./figures"
import { graphql, useStaticQuery } from "gatsby"

const figs = [
  {
    _typename: "thumbnail",
    reference: "1",
    image: "V01",
    size: 5,
    caption_en: {
      title: "Concarneau",
      body: ", 1924<br/>Drawing removed from <em>Sketchbook no. 4</em><br/>Pencil on paper<br/>25,3 x 19 cm",
      source: "Collection of the Leonard & Bina Ellen Art Gallery, Concordia University<br/>Gift of the Anne Savage Estate, 1989<br/>Photo: Paul Litherland",
    },
    caption_fr: {
      title: "Concarneau",
      body:
        ", 1924<br/>Dessin tiré du <em>Carnet de croquis no 4</em><br/>Crayon sur papier<br/>25,3 x 19 cm",
      source:
        "Collection de la Galerie Leonard & Bina Ellen, Université Concordia<br/>Don de la succession Anne Savage, 1989<br/>Photo : Paul Litherland",
    },
  },
  {
    _typename: "thumbnail",
    reference: "2",
    image: "V02",
    size: 5,
    caption_en: {
      title: "Quimper",
      body: ", 1924<br/>Drawing removed from <em>Sketchbook no. 4</em><br/>Pencil on paper<br/>25,3 x 19 cm",
      source: "Collection of the Leonard & Bina Ellen Art Gallery, Concordia University<br/>Gift of the Anne Savage Estate, 1989<br/>Photo: Paul Litherland",
    },
    caption_fr: {
      title: "Quimper",
      body:
        ", 1924<br/>Dessin tiré du <em>Carnet de croquis no 4</em><br/>Crayon sur papier<br/>25,3 x 19 cm",
      source:
        "Collection de la Galerie Leonard & Bina Ellen, Université Concordia<br/>Don de la succession Anne Savage, 1989<br/>Photo : Paul Litherland",
    },
  },
  {
    _typename: "thumbnail",
    reference: "3",
    image: "V03",
    size: 4,
    caption_en: {
      title: "The Skeena",
      body: ", n.d.<br/>Ink on paper <br/>10 x 12 cm",
      source: "Collection of the Leonard & Bina Ellen Art Gallery, Concordia University<br/>Gift of Mrs. T.W.L. McDermot, 1984<br/>Photo: Paul Litherland",
    },
    caption_fr: {
      title: "La Skeena",
      body: ", n. d.<br/>Encre sur papier<br/>10 x 12 cm",
      source:
        "Collection de la Galerie Leonard & Bina Ellen, Université Concordia<br/>Don de la succession Anne Savage, 1989<br/>Photo : Paul Litherland",
    },
  },
  {
    _typename: "sketchbook",
    reference: "4",
    images: "V04",
    size: 4,
    caption_en: {
      title: "",
      body: "Drawings from <em>Sketchbook no. 11</em>, 1937<br/>Pencil, colour pencil and crayon on paper<br/>38,3 x 21,7 cm",
      source: "Collection of the Leonard & Bina Ellen Art Gallery, Concordia University<br/>Gift of the Anne Savage Estate, 1989<br/>Photo: Paul Litherland",
    },
    caption_fr: {
      body:
        "Dessins tirés du <em>Carnet de croquis no 11</em>, 1937<br/>Crayon, crayon de couleur et crayon de cire sur papier<br/>28,3 x 21,7 cm",
      source:
        "Collection de la Galerie Leonard & Bina Ellen, Université Concordia<br/>Don de la succession Anne Savage<br/>Photo : Paul Litherland",
    },
  },
  {
    _typename: "sketchbook",
    reference: "5",
    images: "V05",
    size: 4,
    caption_en: {
      title: "Sketchbook no. 15",
      body: ", 1949<br/>Pencil and colour pencil and crayon on paper<br/>38,3 x 26,8 cm",
      source: "Collection of the Leonard & Bina Ellen Art Gallery, Concordia University<br/>Gift of the Anne Savage Estate, 1989<br/>Photo: Paul Litherland",
    },
    caption_fr: {
      body:
        "Dessins tirés du <em>Carnet de croquis no 15</em>, 1949<br/>Crayon et crayon de couleur sur papier<br/>38 x 26,8 cm",
      source:
        "Collection de la Galerie Leonard & Bina Ellen, Université Concordia<br/>Don de la succession Anne Savage<br/>Photo : Paul Litherland",
    },
  },
  {
    _typename: "thumbnail",
    reference: "6",
    image: "V06",
    size: 5,
    caption_en: {
      title: "",
      body: "Emily Carr<br/>Catalogue cover, <em>Exhibition of Canadian West Coast Art Native and Modern</em>, National Gallery of Canada, 1927",
      source: "National Gallery of Canada Library and Archive, Ottawa<br/>Photo: NGC",
    },
    caption_fr: {
      body:
        "Emily Carr<br/>Couverture du catalogue, <em>Exhibition of Canadian West Coast Art Native and Modern</em>, Musée des beaux-arts du Canada, 1927",
      source:
        "Bibliothèque et Archives du Musée des beaux-arts du Canada, Ottawa<br/>Photo : MBAC",
    },
  },
  {
    _typename: "thumbnail",
    reference: "7",
    image: "V07",
    size: 3,
    caption_en: {
      title: "",
      body: "Exhibition view, <em>Exhibition of Canadian West Coast Art Native and Modern</em>, 1927.",
      source: "National Gallery of Canada Library and Archives, Ottawa<br/>Photo: NGC<br/>Savage’s painting Temlaham, Upper Skeena River is on the center left of the image.",
    },
    caption_fr: {
      body:
        "Vue d’exposition, Exhibition of <em>Canadian West Coast Art Native and Modern</em>, 1927",
      source:
        "Bibliothèque et Archives du Musée des beaux-arts du Canada, Ottawa<br/>Photo : MBAC<br/>Le tableau de Savage Temlaham, Upper Skeena River se trouve au centre gauche de l’image.",
    },
  },
  {
    _typename: "thumbnail",
    reference: "8.1",
    image: "V08_1",
    size: 2,
    caption_en: {
      title: "",
      body: "Marius Barbeau, <em>The Downfall of Temlaham</em> (Toronto: Macmillan Company, 1928).",
      source: "Concordia University Library<br/>Photo: Paul Litherland",
    },
    caption_fr: {
      body:
        "Marius Barbeau, <em>The Downfall of Temlaham</em>, Toronto, Macmillan Company, 1928.",
      source:
        "Bibliothèque de l’Université Concordia<br/>Photo : Paul Litherland",
    },
  },
  {
    _typename: "thumbnail",
    reference: "8.2",
    image: "V08_2",
    size: 2,
    caption_en: {
      title: "",
      body: "<em>Paradise Lost</em>, 1927<br/>Reproduced in Marius Barbeau, The Downfall of Temlaham (Toronto: Macmillan Company, 1928), 222.",
      source: "Concordia University Library<br/>Photo: Paul Litherland",
    },
    caption_fr: {
      title: "Paradis perdu",
      body:
        ", 1927<br/>Reproduit dans Marius Barbeau, <em>The Downfall of Temlaham</em>, Toronto, Macmillan Company, 1928, p. 222.",
      source:
        "Bibliothèque de l’Université Concordia<br/>Photo : Paul Litherland",
    },
  },
  {
    _typename: "sound",
    reference: "9",
    sound: "V09",
    size: 1,
    caption_en: {
      title: "",
      body: "Arthur H. Calvin, <em>Interview with Anne Savage</em>, September 1967, Anne Savage Fonds, Concordia University Archives, file 18.3, tape 1, 00:40:40 - 00:42:28.",
      source: "",
    },
    caption_fr: {
      body:
        "Arthur H. Calvin, <em>Entretiens avec Anne Savage</em>, septembre 1967, Fonds Anne Savage, Archives de l’Université Concordia, document 18.3, cassette 1, 00:40:40 - 00:42:28.",
    },
  },
  {
    _typename: "thumbnail",
    reference: "10",
    image: "V10",
    size: 9,
    caption_en: {
      title: "",
      body: "“Indian Village Forbids Whites,” <em>Vancouver Daily Province</em>, September 17, 1927, Anne Savage Fonds, Concordia University Archives, file 14.158.",
      source: "",
    },
    caption_fr: {
      body:
        "« Indian Village Forbids Whites »,” <em>Vancouver Daily Province</em>, 17 septembre 1927, Fonds Anne Savage, Archives de l’Université Concordia, document 14.158.",
    },
  },
  {
    _typename: "sketchbook",
    reference: "11",
    images: "V11",
    size: 3,
    caption_en: {
      body: `
      <em>Sketchbook</em>, 1927<br/>Graphite on onion skin paper <br/>25 x 20 cm
      <div class="caption__source" style="margin-bottom: 2em;">National Gallery of Canada, Ottawa<br/>Photo: NGC</div>
      <span class="caption__reference">11.1</span><em>Mountain Landscape</em><br/>
      <span class="caption__reference">11.2</span><em>Landscape</em><br/>
      <span class="caption__reference">11.3</span><em>Village Scene</em><br/>
      <span class="caption__reference">11.4</span><em>Maily Smith, Kispyox</em><br/>
      <span class="caption__reference">11.5</span><em>Kitwanga</em><br/>
      <span class="caption__reference">11.6</span><em>Kitwancool</em><br/>
      <span class="caption__reference">11.7</span><em>Houses and Totem <br/><span class="caption__reference"></span>Poles</em><br/>
      <span class="caption__reference">11.8</span><em>Kitselas Canyon</em><br/>
      <span class="caption__reference">11.9</span><em>Horn Spoons</em><br/>
      <span class="caption__reference">11.10</span><em>Kidkshan Masks</em><br/>
      <span class="caption__reference">11.11</span><em>The Gruaghan Totem</em><br/>
      <span class="caption__reference">11.12</span><em>Head of a Woman</em><br/>
      `
    },
    caption_fr: {
      body: `
      <em>Carnet de croquis</em>, 1927<br/>Mine de plomb sur papier pelure<br/>25 x 20 cm
      <div class="caption__source" style="margin-bottom: 2em;">Musée des beaux-arts du Canada, Ottawa<br/>Photo : MBAC</div>
      <span class="caption__reference">11.1</span><em>Paysage <br/><span class="caption__reference"></span>montagneux</em><br/>
      <span class="caption__reference">11.2</span><em>Paysage</em><br/>
      <span class="caption__reference">11.3</span><em>Scène de village</em><br/>
      <span class="caption__reference">11.4</span><em>Maily Smith Kispyox</em><br/>
      <span class="caption__reference">11.5</span><em>Kitwanga</em><br/>
      <span class="caption__reference">11.6</span><em>Kitwancool</em><br/>
      <span class="caption__reference">11.7</span><em>Maisons et mâts <br/><span class="caption__reference"></span>totémiques</em><br/>
      <span class="caption__reference">11.8</span><em>Kitselas Canyon</em><br/>
      <span class="caption__reference">11.9</span><em>Cuillères de corne</em><br/>
      <span class="caption__reference">11.10</span><em>Masques Kidkshan</em><br/>
      <span class="caption__reference">11.11</span><em>Le totem des <br/><span class="caption__reference"></span>Gruaghan</em><br/>
      <span class="caption__reference">11.12</span><em>Tête d’une femme</em><br/>
      `
    },
  },
  {
    _typename: "sketchbook",
    reference: "12",
    images: "V12",
    size: 4,
    caption_en: {
      title: "Sketchbook no.&nbsp;3",
      body: ", 1949<em>Pencil and colour pencil on paper<em>22,8 x 15,2 cm",
      source: "Collection of the Leonard & Bina Ellen Art Gallery, Concordia University<br/>Gift of the Anne Savage Estate, 1989<br/>Photo: Paul Litherland",
    },
    caption_fr: {
      body:
        "<em>Carnet de croquis no&nbsp;3</em>, 1949<br/>Crayon et crayon de couleur sur papier<br/>22,8 x 15,2 cm",
      source:
        "Collection de la Galerie Leonard & Bina Ellen, Université Concordia<br/>Don de la succession Anne Savage, 1989<br/>Photo : Paul Litherland",
    },
  },
  {
    _typename: "sketchbook",
    reference: "13",
    images: "V13",
    size: 4,
    caption_en: {
      title: "Sketchbook no.&nbsp;12",
      body: ", 1949<br/>Pencil, crayon and felt pen on paper<br/>25,3 x 17,8 cm",
      source: "Collection of the Leonard & Bina Ellen Art Gallery, Concordia University<br/>Gift of the Anne Savage Estate, 1989<br/>Photo: Paul Litherland",
    },
    caption_fr: {
      body:
        "<em>Carnet de croquis no&nbsp;12</em>, 1949<br/>Crayon, crayon de cire et crayon feutre sur papier<br/>25,3 x 17,8 cm",
      source:
        "Collection de la Galerie Leonard & Bina Ellen, Université Concordia<br/>Don de la succession Anne Savage, 1989<br/>Photo : Paul Litherland",
    },
  },
  {
    _typename: "thumbnail",
    reference: "14",
    image: "V14",
    size: 4,
    caption_en: {
      title: "The Skeena River – B.C.",
      body: ", c. 1927<br/>Oil on panel<br/>23 x 30,5 cm",
      source: "Collection of the Leonard & Bina Ellen Art Gallery, Concordia University<br/>Gift of Mrs. Anne Hirsh, 2003<br/>Photo: Paul Litherland",
    },
    caption_fr: {
      title: "La rivière Skeena - C.&#8209;B.",
      body: ", vers 1927<br/>Huile sur panneau<br/>23 x 30,5 cm",
      source:
        "Collection de la Galerie Leonard & Bina Ellen, Université Concordia<br/>Don de Mme Anne Hirsh, 2003<br/>Photo : Paul Litherland",
    },
  },
  {
    _typename: "thumbnail",
    reference: "15",
    image: "V15",
    size: 5,
    caption_en: {
      title: "Untitled",
      body: ", n.d.<br/>Charcoal and tempera on paper <br/>50,6 x 35,5 cm",
      source: "Collection of the Leonard & Bina Ellen Art Gallery, Concordia University<br/>Gift of the Anne Savage Estate, 1989<br/>Photo: Paul Litherland",
    },
    caption_fr: {
      title: "Sans titre",
      body: ", n. d.<br/>Fusain et détrempe sur papier<br/>50,6 x 35,5 cm",
      source:
        "Collection de la Galerie Leonard & Bina Ellen, Université Concordia<br/>Don de la succession Anne Savage, 1989<br/>Photo : Paul Litherland",
    },
  },
  {
    _typename: "thumbnail",
    reference: "16",
    image: "V16",
    size: 1,
    caption_en: {
      title: "",
      body: "Canadian National Railways<br/><em>Map of Alaska and the Yukon. Canadian Rockies and the Triangular Tour of British Columbia</em>, 1927",
      source: "Cornell University Library – PJ Mode Collection of Persuasive Cartography",
    },
    caption_fr: {
      body:
        "Canadian National Railways<br/><em>Map of Alaska and the Yukon. Canadian Rockies and the Triangular Tour of British Columbia</em>, 1927",
      source:
        "Cornell University Library – PJ Mode Collection of Persuasive Cartography",
    },
  },
]

export default ({ size }) => {
  const data = useStaticQuery(query)

  return <Figures data={data} figures={figs} pre="voyager" size={size} />
}

export const query = graphql`
  query {
    V01: file(relativePath: { eq: "voyager/V_01.jpg" }) {
      ...thumbnailImage
    }
    V02: file(relativePath: { eq: "voyager/V_02.jpg" }) {
      ...thumbnailImage
    }
    V03: file(relativePath: { eq: "voyager/V_03.jpg" }) {
      ...thumbnailImage
    }
    V04: allFile(
      filter: {
        relativePath: { regex: "/^voyager/V_04_Sketchbook 11/" }
        sourceInstanceName: { eq: "images" }
      }
      sort: { fields: base }
    ) {
      edges {
        node {
          base
          ...thumbnailImage
        }
      }
    }
    V05: allFile(
      filter: {
        relativePath: { regex: "/^voyager/V_05_Sketchbook 15/" }
        sourceInstanceName: { eq: "images" }
      }
      sort: { fields: base }
    ) {
      edges {
        node {
          base
          ...thumbnailImage
        }
      }
    }
    V06: file(relativePath: { eq: "voyager/V_06.jpg" }) {
      ...thumbnailImage
    }
    V07: file(relativePath: { eq: "voyager/V_07.jpg" }) {
      ...thumbnailImage
    }
    V08_1: file(relativePath: { eq: "voyager/V_08.1.jpg" }) {
      ...thumbnailImage
    }
    V08_2: file(relativePath: { eq: "voyager/V_08.2.jpg" }) {
      ...thumbnailImage
    }
    V09: file(relativePath: { eq: "voyager/V_09.mp3" }) {
      publicURL
    }
    V10: file(relativePath: { eq: "voyager/V_10.jpg" }) {
      ...thumbnailImage
    }
    V11: allFile(
      filter: {
        relativePath: { regex: "/^voyager/Sketchbook/" }
        sourceInstanceName: { eq: "images" }
      }
      sort: { fields: base }
    ) {
      edges {
        node {
          base
          ...thumbnailImage
        }
      }
    }
    V12: allFile(
      filter: {
        relativePath: { regex: "/^voyager/V_23_Sketchbook 3/" }
        sourceInstanceName: { eq: "images" }
      }
      sort: { fields: base }
    ) {
      edges {
        node {
          base
          ...thumbnailImage
        }
      }
    }
    V13: allFile(
      filter: {
        relativePath: { regex: "/^voyager/V_24_Sketchbook 12/" }
        sourceInstanceName: { eq: "images" }
      }
      sort: { fields: base }
    ) {
      edges {
        node {
          base
          ...thumbnailImage
        }
      }
    }
    V14: file(relativePath: { eq: "voyager/V_25.jpg" }) {
      ...thumbnailImage
    }
    V15: file(relativePath: { eq: "voyager/V_26.jpg" }) {
      ...thumbnailImage
    }
    V16: file(relativePath: { eq: "voyager/V_27.jpg" }) {
      ...thumbnailImage
    }
  }
`
